<template>
  <div id="footer-view">
    <ol>
      <li v-for="item in items"
      v-on:click="onClick(item.path)"
      > {{ item.title }}
    </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'FooterView',
  data () {
    return {
      title: 'this will head',
      items: [
        { title: 'top', path: '' },
        { title: 'profile', path: 'profile' },
        { title: 'intern', path: 'appeal' },
        // { title: 'skills', path: 'skills' },
        { title: 'outputs', path: 'outputs' }
      ]
    }
  },

  methods: {
    onClick: function(path) {
      scroll(0,0)
      window.location.href = `#/${path}`
    }
  }
}


</script>

<style scoped>

div {
  background-color: #eee;
  text-align: center;
  width: 100%;
  height: 80px;
  position: fixed;	/* フッターを固定する */
  bottom: 0;
  /* width: 100%; */
}

ol {
  /* background-color: green; */
  width: 100%;
  display:flex;
  justify-content: center;
  padding: 0;
  list-style: none;
}

#footer-view li {

  width: 50px;
  height: 50px;
  margin-left:10px;
  margin-right:10px;
  font-size: 14px;
  border-radius: 25px;
  background-color: skyblue;
  color: white;
  line-height: 50px
}



</style>



// WEBPACK FOOTER //
// src/components/FooterView.vue